import { useMemo } from "react";
import { useAuthStore } from "../store/authStore";

/**
 * Permission helper hook.
 *
 *   const { can, roleName, isGroupAdmin } = usePermission();
 *   can("families")             // can view families
 *   can("children", "is_add")   // can add a child
 *
 * The database is the source of truth — every role must have an explicit
 * tbrole_permissions row to gain access.
 */
export const usePermission = () => {
  const user = useAuthStore((s) => s.user);
  const rawPermissions = useAuthStore((s) => s.permissions);

  const roleName = (user?.role_name || "").toLowerCase();
  const isGroupAdmin = roleName === "group_admin";

  const permissions = useMemo(() => rawPermissions || [], [rawPermissions]);

  const permissionsByCode = useMemo(() => {
    const map = {};
    for (const p of permissions) map[p.code] = p;
    return map;
  }, [permissions]);

  const can = (code, action = "is_view") => {
    if (!code) return false;
    const row = permissionsByCode[code];
    return !!(row && Number(row[action]) === 1);
  };

  return { can, roleName, isGroupAdmin, permissions, permissionsByCode };
};
